import React, { useState, useEffect } from "react";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Menu,
  MenuItem,
  TextField,
  Select,
  FormControl,
  InputLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Modal,
  IconButton,
  Typography,
  TablePagination,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Close } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import { useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { useFetch, useUpdate, useDelete } from "../../hooks";

const Sliders = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [errors, setErrors] = useState({});
  const [sliderForm, setSliderForm] = useState({ name: "", logo: "" });
  const [isEditMode, setEditMode] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [open, setOpen] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedSliderId, setSelectedSliderId] = useState(null);
  const [data, setData] = useState("");
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [snackbarState, setSnackbarState] = useState({
    message: "",
    status: "",
  });

  // Pagination states
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const loginToken = useSelector((state) => state.user.logintoken);
  const initializeSliders = () => {
    setSliderForm({
      name: "",
      logo: "",
    });
  };

  //get All sliders data
  useEffect(() => {
    fetchData();
  }, []);

  //get All Sliders data
  const {
    data: slidersData,
    isLoading: isSlidersLoading,
    error,
    fetchData,
  } = useFetch(BASE_URL_TEST + urls("getAllSliders"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });
  const {
    data: createSlidersData,
    isLoading: createSlidersLoading,
    error: createSlidersError,
    fetchData: fetchCreateData,
  } = useFetch(BASE_URL_TEST + urls("createSlider"), {
    method: "POST",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: updateSlidersData,
    isLoading: updateSlidersLoading,
    error: updateSlidersError,
    updateData: fetchUpdateData,
  } = useUpdate(BASE_URL_TEST, {
    method: "PUT",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });
  const {
    data: deleteSlidersData,
    isLoading: deleteSlidersLoading,
    error: deleteSlidersError,
    deleteData: fetchDeleteData,
  } = useDelete(BASE_URL_TEST, {
    method: "DELETE",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  useEffect(() => {
    if (error) {
    } else if (slidersData && slidersData["status"] === true) {
      setData(slidersData["data"]);
    }
  }, [slidersData, error]);

  //Create Sliders
  useEffect(() => {
    if (createSlidersError) {
    } else if (createSlidersData && createSlidersData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: createSlidersData["message"],
        status: createSlidersData["status"],
      });
      setModalOpen(true);
      fetchData();
    } else if (createSlidersData && createSlidersData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: createSlidersData["message"],
        status: createSlidersData["status"],
      });
      setModalOpen(true);
      fetchData();
    }
  }, [createSlidersData, createSlidersError]);

  //Update Sliders
  useEffect(() => {
    if (updateSlidersError) {
    } else if (updateSlidersData && updateSlidersData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: updateSlidersData["message"],
        status: updateSlidersData["status"],
      });
      setModalOpen(true);
      fetchData();
    } else if (updateSlidersData && updateSlidersData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: updateSlidersData["message"],
        status: updateSlidersData["status"],
      });
      setModalOpen(true);
      fetchData();
    }
  }, [updateSlidersData, updateSlidersError]);

  //Delete Sliders
  useEffect(() => {
    if (deleteSlidersError) {
    } else if (deleteSlidersData && deleteSlidersData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: deleteSlidersData["message"],
        status: deleteSlidersData["status"],
      });
      setDeleteModalOpen(true);
      fetchData();
    } else if (deleteSlidersData && deleteSlidersData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: deleteSlidersData["message"],
        status: deleteSlidersData["status"],
      });
      setDeleteModalOpen(true);
      fetchData();
    }
  }, [deleteSlidersData, deleteSlidersError]);

  // Filter data based on search
  const filteredData =
    data && data.length > 0
      ? data
          .sort((a, b) => b.banner_id - a.banner_id) // Sort by ID in descending order
          .filter(
            (item) =>
              item.type === "slider" && // "Slider" type data
              ((item.banner_id &&
                item.banner_id
                  .toString()
                  .toLowerCase()
                  .includes(search.toLowerCase())) ||
                (item.name &&
                  item.name.toLowerCase().includes(search.toLowerCase())))
          )
      : data;

  const handleSearch = (event) => setSearch(event.target.value);

  const handleMenuOpen = (event, sliderId) => {
    setAnchorEl(event.currentTarget);
    setSelectedSliderId(sliderId);
  };

  const handleMenuClose = () => setAnchorEl(null);

  const handleEdit = (sliderData) => {
    setEditMode(true);
    setOpen(true);
    setSliderForm({
      ...sliderForm,
      name: sliderData["name"],
      logo: sliderData["image_url"],
      status:
        sliderData["status"] === 1
          ? "Active"
          : sliderData["status"] === 0
          ? "Inactive"
          : "",
      id: sliderData["banner_id"],
    });
    setAnchorEl(null);
  };

  // Handle delete
  const handleDelete = (sliderId) => {
    const deleteUrl = urls("deleteSlider", sliderId);
    fetchDeleteData(deleteUrl);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setSliderForm({ name: "", logo: "" });
    setEditMode(false);
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSliderForm({
        ...sliderForm,
        logo: URL.createObjectURL(e.target.files[0]),
      });
      setSelectedFile(file);
    }
  };

  const handleSubmit = () => {
    let validationErrors = {};
    if (!sliderForm.logo) {
      validationErrors.logoError = "please upload Image";
      setErrors(validationErrors);
      return;
    }
    console.log("formdata");
    setErrors({});

    const formdata = new FormData();
    formdata.append("type", "slider");
    formdata.append("name", sliderForm["name"]);
    formdata.append("description", "");
    formdata.append(
      "imageurl",
      selectedFile ? selectedFile : sliderForm["image_url"]
    );
    if (isEditMode) {
      formdata.append(
        "status",
        sliderForm["status"] === "Active"
          ? 1
          : sliderForm["status"] === "Inactive"
          ? 0
          : ""
      );
      for (let [key, value] of formdata.entries()) {
        console.log("Form Data Contentsupdate:", `${key}: ${value}`);
      }
      const updateUrl = urls("updateSlider", sliderForm["id"]);
      fetchUpdateData(updateUrl, formdata);
    } else if (!isEditMode) {
      for (let [key, value] of formdata.entries()) {
        console.log("Form Data Contents:", `${key}: ${value}`);
      }
      fetchCreateData(formdata);
    }
  };

  // Pagination handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleAdd = () => {
    setEditMode(false);
    initializeSliders();
    setErrors({});
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setModalOpen(false);
    setDeleteModalOpen(false);
    setErrors({});
    if (!createSlidersError) {
      setErrors({});
    }
    if (isEditMode) {
      if (!updateSlidersError) {
        setErrors({});
      }
    }

    setSnackbarState({
      message: "",
      status: "",
    });
  };

  return (
    <Box sx={{ padding: 2, backgroundColor: "#F9FAFC" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <TextField
          variant="outlined"
          placeholder="Search"
          size="small"
          value={search}
          onChange={handleSearch}
          sx={{ width: "30%", backgroundColor: "#FFF", borderRadius: 1 }}
        />
        <Button
          variant="contained"
          color="success"
          startIcon={<AddIcon />}
          onClick={handleAdd}
        >
          Add
        </Button>
      </Box>
      <TableContainer component={Paper} sx={{ borderRadius: "20px" }}>
        <Table>
          <TableHead sx={{ backgroundColor: "#F5F5F5" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>ID</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Image</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>STATUS</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>ACTION</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={2} align="center">
                  <Typography>No records found</Typography>
                </TableCell>
              </TableRow>
            ) : (
              filteredData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((slider) => {
                  return (
                    <TableRow key={slider.banner_id}>
                      <TableCell>{slider.banner_id}</TableCell>
                      <TableCell>{slider.name}</TableCell>
                      <TableCell>
                        {slider.image_url ? (
                          <img
                            src={slider.image_url}
                            alt="logo"
                            width={40}
                            height={40}
                          />
                        ) : (
                          "No Image"
                        )}
                      </TableCell>
                      <TableCell>
                        <Typography
                          color={
                            slider.status === "Active"
                              ? "green"
                              : slider.status === "Inactive"
                              ? "red"
                              : "orange"
                          }
                        >
                          {slider.status == 1
                            ? "Active"
                            : slider.status == 0
                            ? "Inactive"
                            : ""}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <MoreVertIcon
                          onClick={(e) => handleMenuOpen(e, slider.banner_id)}
                        />
                        <Menu
                          anchorEl={anchorEl}
                          open={
                            Boolean(anchorEl) &&
                            selectedSliderId === slider.banner_id
                          }
                          onClose={handleMenuClose}
                        >
                          <MenuItem onClick={() => handleEdit(slider)}>
                            {/* <EditIcon /> */}
                            Edit
                          </MenuItem>
                          <MenuItem
                            onClick={() => handleDelete(slider.banner_id)}
                          >
                            {/* <DeleteIcon />  */}
                            Delete
                          </MenuItem>
                        </Menu>
                      </TableCell>
                    </TableRow>
                  );
                })
            )}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
      <Dialog
        open={isDeleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      >
        <DialogTitle>
          {snackbarState.status === true ? "Success" : "Error"}
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{
              color: snackbarState.status === true ? "green" : "red",
            }}
          >
            {snackbarState.message}
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleClose}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              alignSelf: "center",
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "calc(100vw - 24px)", sm: 400 },
            maxWidth: "100%",
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            position: "relative",
          }}
        >
          <IconButton
            sx={{ position: "absolute", top: 8, right: 8 }}
            onClick={() => setOpen(false)}
          >
            <Close />
          </IconButton>
          <Typography variant="h6" mb={2}>
            {isEditMode ? "Edit Slider" : "Add Slider"}
          </Typography>
          <TextField
            name="name"
            label="Name"
            fullWidth
            margin="dense"
            value={sliderForm.name}
            onChange={(e) =>
              setSliderForm({
                ...sliderForm,
                name: e.target.value,
              })
            }
            sx={{ mb: 2 }}
          />
          <input type="file" accept="image/*" onChange={handleImageUpload} />
          {errors.logoError && (
            <Typography color="error" sx={{ mt: 1 }}>
              {errors.logoError}
            </Typography>
          )}
          {sliderForm.logo && (
            <img src={sliderForm.logo} alt="Preview" width={50} height={50} />
          )}
          {isEditMode && (
            <FormControl fullWidth sx={{ mt: 3 }}>
              <InputLabel id="status-label">Status</InputLabel>
              <Select
                labelId="status-label"
                id="status-select"
                value={sliderForm?.status || ""}
                onChange={(e) =>
                  setSliderForm({
                    ...sliderForm,
                    status: e.target.value,
                  })
                }
                label="Status"
              >
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Inactive">Inactive</MenuItem>
              </Select>
            </FormControl>
          )}
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button onClick={handleModalClose}>Cancel</Button>
            <Button variant="contained" color="success" onClick={handleSubmit}>
              {isEditMode ? "Update" : "Add"}
            </Button>
          </Box>
        </Box>
      </Modal>
      <Dialog open={isModalOpen} onClose={() => setModalOpen(false)}>
        <DialogTitle>
          {snackbarState.status === true ? "Success" : "Error"}
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{
              color: snackbarState.status === true ? "green" : "red",
            }}
          >
            {snackbarState.message}
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleClose}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              alignSelf: "center",
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Sliders;
